
export default {
	props: {
		price: {
			type: [Number, String],
            required:true
		}
	}
}
